import type { OrderItem } from './types';

export const buildOrderDetailLine = (
  item: OrderItem,
  unit: string,
  image: string | null = null
) => ({
  item: item.item,
  quantity: item.quantity,
  unit,
  note: item.note || '',
  image,
  ...(item.restaurant_inventory_item_id
    ? { restaurant_inventory_item_id: item.restaurant_inventory_item_id }
    : {}),
  ...(item.multiplier != null && item.multiplier > 0
    ? { multiplier: item.multiplier }
    : {}),
  ...(item.base_unit?.trim() ? { base_unit: item.base_unit.trim() } : {})
});
